import { CouponEntity } from "@modules/common/couponObject/entities/couponObjectEntity"
import { PriceObjectEntity } from "@modules/common/priceObject/entities/priceObjectEntity"
import { type PaymentError } from "@modules/finances/types/stripeErrorTypes"
import { UserEntity } from "@modules/profile/userProfile/userEntity"
import { LightPromoCodeEntity } from "@modules/promoCode/entities/lightPromoCodeEntity"

export const ProgramContentTypeOf = "PROGRAM"
export const ProgramProTypeOf = "PROGRAM_PRO"

export enum ProgramVisibility {
  PRIVATE = "PRIVATE",
  PUBLIC = "PUBLIC",
  MEMBERS = "MEMBERS",
}

export enum ProgramType {
  VIRTUAL = "VIRTUAL",
  ONOFF = "ON_OFF",
  IN_BOX = "IN_BOX",
  EVENT = "EVENT",
  PRO = "PRO",
}

export type SessionsProgramType = ProgramType.VIRTUAL | ProgramType.PRO | ProgramType.ONOFF

// Used by the On/Off programs; as long as the program is not completed, it is considered a draft.
export enum ProgramStatus {
  DRAFT = "DRAFT",
  PUBLISHED = "PUBLISHED",
}

export enum ProgramSubscriptionStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  PAUSE = "PAUSE",
  PAYMENT_IN_ERROR = "PAYMENT_IN_ERROR",
  PENDING_CANCELLATION = "PENDING_CANCELLATION",
  PENDING_PAYMENT = "PENDING_PAYMENT",
  PENDING_REQUEST = "PENDING_REQUEST",
  TRIALING = "TRIALING",
  TRIAL_PENDING_CANCELLATION = "TRIAL_PENDING_CANCELLATION",
  ACTIVE_BUNDLE = "ACTIVE_BUNDLE", // Program of a bundle - followed
  INACTIVE_BUNDLE = "INACTIVE_BUNDLE", // Program of a bundle - unfollowed
}

export enum ProgramFilter {
  OWNED = "OWNED",
  SUBSCRIBED = "SUBSCRIBED",
  SHARED_COACH = "SHARED_COACH",
  ALL = "ALL",
}

export type ProgramPayment = {
  amount: PriceObjectEntity
  promoCode: LightPromoCodeEntity | null
  coupon: CouponEntity | null
  error: PaymentError | null
}

export enum SharedCoachStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  REFUSED = "REFUSED",
}

export type SharedCoach = {
  role: string // TODO refactor with SharedCoachRole
  status: SharedCoachStatus
  user: UserEntity
}

export enum SharedCoachRequestAction {
  ACCEPT = "ACCEPT",
  REFUSE = "REFUSE",
  QUIT = "QUIT",
  REMOVE = "REMOVE",
}
